import { ListColumn, ListDataColumn } from "../ListColumn";
import { QueryListView } from "./QueryListView";
import { WebTraderListView } from "./WebTraderListView";

export class InBoxListView extends WebTraderListView{

    constructor(items:any){
        let itemsWithChecked = items;
        if (Object.keys(items).length > 0) {
            itemsWithChecked = items.map((info: any) => ({checked: false, ...info}));
        }
        const columns = [
            new ListColumn("Num", ListDataColumn.TEXT, "num"),
            new ListColumn("File Name", ListDataColumn.TEXT, "code"),
            new ListColumn("Message Number", ListDataColumn.TEXT, "name"),
            new ListColumn("Receiver ID", ListDataColumn.TEXT, "receiver"),
            new ListColumn("Sender ID", ListDataColumn.TEXT, "sender"),
            new ListColumn("Receive Date", ListDataColumn.DATETIME, "receiveDate")
        ]

        super(itemsWithChecked, columns);

    }
}